import api from 'api'
import { z } from 'zod'

export const pushWorkerAssociationRequestSchema = z.object({
  workerId: z.number().int(),
  shiftId: z.number().int(),
  agencyId: z.string(),
  shiftType: z.string(),
})

export type PushWorkerAssociationRequest = z.infer<
  typeof pushWorkerAssociationRequestSchema
>

export const pushWorkerAssociation = async (
  request: PushWorkerAssociationRequest
): Promise<void> => {
  const parsedRequest = pushWorkerAssociationRequestSchema.parse(request)

  await api.post('/admin/dayforce/push_worker_association', parsedRequest)
}
